import { request } from './request';

const baseURL = '/api/catalog';

// Public, cacheable list of LoRaWAN devices with a built-in decoder.
export const list = async () => {
  const response = await request(baseURL);
  return (response && response.data) || [];
};

export const get = (id) => request(`${baseURL}/${encodeURIComponent(id)}`);
